import { render, staticRenderFns } from "./HomepageSellingPoints.vue?vue&type=template&id=63431002"
import script from "./HomepageSellingPoints.vue?vue&type=script&lang=js"
export * from "./HomepageSellingPoints.vue?vue&type=script&lang=js"
import style0 from "./HomepageSellingPoints.vue?vue&type=style&index=0&id=63431002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports